import { CallApi } from 'common/network';
import { API_BASE_URL } from 'settings/App';

/**
 * Check the Internet connection
 *
 * @param {number} id - device id
 */
export const checkInternet = (id, callback) => async () => {
  const { data } = await CallApi({
    method: 'POST',
    url: `${API_BASE_URL}/device/${id}/modem-issue`,
    fetchingId: 'CHECK_INTERNET',
  });

  if (typeof callback === 'function') {
    callback(data.payload.status_code);
  }
};

export default checkInternet;



// WEBPACK FOOTER //
// ./src/common/actions/checkInternet.js